module.exports = __webpack_public_path__ + "static/pic03-c4997bf7d122880e58f2be10723b64ff.jpg";